import { Button } from "primereact/button"
import { JVDropdown } from "../../shared/JVDropdown"
import { JVInput } from "../../shared/JVInput"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IBranchMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { IEmptyEmployee } from "./Form";
import { EmptyFilter } from "./Table";
import { IModal } from "./Employee";

export interface IEmptyFilter{
    employee_Name: string | null,
    email: string | null,
    branch_ID: number | null,
}

interface Iprops {
    filter: IEmptyFilter,
    setFilter: (filter: IEmptyFilter) => void,
}

const schema = yup.object({
    employee_Name: yup.string().nullable(),
    email: yup.string().nullable(),
    branch_ID: yup.number().nullable(),
});

export const Filter = (props: Iprops) => {
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IEmptyFilter>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: props.filter
    });


    const onSubmit=(data: IEmptyFilter)=>{
        props.setFilter(data);
    }

    const loadBranches = async () => {
        const response = await Fetch("Dropdown/branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }

    useEffect(()=>{
        loadBranches();
    },[])

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={3} label="Emp Name:" control={control} name="employee_Name" />
                <JVInput column={3} label="Email:" control={control} name="email" />
                <JVDropdown column={3} label="Branch:" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />

                <div style={{ margin: '10px 0', width: '100%' }}></div>

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
        </>
    )
}